export default __webpack_public_path__ + "5f94509fc7f92e7b8e3a3ac7df529533.png";